import LogoLongImg from "../../assets/imgs/logo/logo-long.png";
import LogoLongImgWhite from "../../assets/imgs/logo/logo-long-white.png";
type LogoLongProps = {
    height?: string;
    type?: "primary" | "white";
};

export default function LogoLong({ height, type = "primary" }: LogoLongProps) {
    if (type === "primary") {
        return <img src={LogoLongImg} alt="mile logo" height={height} />;
    }
    if (type === "white") {
        return <img src={LogoLongImgWhite} alt="mile logo" height={height} />;
    }
}
